import { render, staticRenderFns } from "./MoneyInputWithPreviousValue.vue?vue&type=template&id=2797c1c0&scoped=true&"
import script from "./MoneyInputWithPreviousValue.vue?vue&type=script&lang=js&"
export * from "./MoneyInputWithPreviousValue.vue?vue&type=script&lang=js&"
import style0 from "./MoneyInputWithPreviousValue.vue?vue&type=style&index=0&id=2797c1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797c1c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
